import { MatDateFormats } from '@angular/material/core';

export const APP_MAT_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: 'DD MM YYYY'
  },
  display: {
    dateInput: 'DD MM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD MM YYYY',
    monthYearA11yLabel: 'MMM YYYY'
  }
};
